import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Col, Button } from "shards-react";

import SidebarMainNavbar from "./SidebarMainNavbar";
import SidebarNavItems from "./SidebarNavItems";
import getSidebarNavItems from "../../../data/sidebar-nav-items";
import AuthService from "../../../services/auth-service/AuthService";
import Route from "../../../utils/Route";
import Storage from "../../../services/storage-service/Storage";
import { TextOnlyOrganization } from "./Organizations/style";
import { useNavigate } from "react-router-dom";

const MainSidebar = ({ hideLogoText, pageNumber }) => {
    const [sidebarNavItems, setSidebarNavItems] = useState([]);
    const [organization, setOrganization] = useState(null);
    const [organizationsList, setOrganizationsList] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const userScopes = await AuthService.getDecodedToken().scopes;
            const organizationData = JSON.parse(
                Storage.get(Storage.KEYS.ORGANIZATION_DATA)
            );
            setOrganization(organizationData);

            const organizationsList = JSON.parse(
                Storage.get(Storage.KEYS.ORGANIZATIONS)
            );
            setOrganizationsList(organizationsList);

            const organizationName = organizationData?.name;

            const userProfile = `${
                AuthService.getDecodedToken().role
            }`?.toLowerCase();

            const navItems = getSidebarNavItems();
            const routesWithScope = Route.getRoutesWithScope(navItems);
            const userFreeRoutes = Route.getRoutesWithoutScope(navItems);
            const userScopeAllowedRoutes = routesWithScope.filter(route =>
                userScopes.some(scope => route.requiredScopes.includes(scope))
            );
            const userAllowedRoutes = await Route.removeRouteWithoutDocumentationFile(
                [...userScopeAllowedRoutes, ...userFreeRoutes],
                organizationName,
                userProfile
            );
            setSidebarNavItems(Route.orderRouteItems(userAllowedRoutes));
        };

        fetchData();
    }, []);

    const classes = classNames("main-sidebar", "px-0", "col-12");

    return (
        <Col
            id={"sidebar-menu"}
            tag="aside"
            className={classes}
            lg={{ size: 2 }}
            md={{ size: 3 }}
        >
            <SidebarMainNavbar hideLogoText={hideLogoText} />
            <SidebarNavItems
                sidebarNavItems={sidebarNavItems}
                pageNumber={pageNumber}
            >
                <OrganizationRenderComponent
                    organization={organization}
                    organizationsList={organizationsList}
                    onClickButton={() => navigate("/select-organization")}
                />
            </SidebarNavItems>
        </Col>
    );
};

const OrganizationRenderComponent = ({
    organization,
    organizationsList,
    onClickButton
}) => {
    const setInfos = () => {
        return {
            subTitle: organization ? "Sua organização" : "Nenhuma organização",
            organizationName: organization?.name,
            showChangeOrganization: organizationsList?.length > 1
        };
    };

    return (
        <TextOnlyOrganization
            style={{
                minHeight: setInfos().showChangeOrganization ? "130px" : ""
            }}
        >
            <div>
                <p style={{ margin: 0, fontSize: 14 }}>{setInfos().subTitle}</p>
                <p style={{ margin: 0, fontSize: 16, fontWeight: "bold" }}>
                    {setInfos().organizationName}
                </p>
            </div>
            <div>
                {setInfos().showChangeOrganization ? (
                    <Button theme="primary" block onClick={onClickButton}>
                        Selecionar organização
                    </Button>
                ) : (
                    ""
                )}
            </div>
        </TextOnlyOrganization>
    );
};

MainSidebar.propTypes = {
    hideLogoText: PropTypes.bool,
    pageNumber: PropTypes.string
};

MainSidebar.defaultProps = {
    hideLogoText: false
};

export default MainSidebar;
